<template>
  <div class="aff-login-page">
    <div class="aff-login-card">
      <div class="aff-login-logo">
        <img src="https://img.jiliskin.com/jili_logo_600.png" alt="JiLi 肌黎" class="aff-logo-img" @error="$event.target.style.display='none'" />
        <h1>合作夥伴登入</h1>
      </div>

      <form @submit.prevent="login" class="aff-login-form">
        <div class="aff-field">
          <label>帳號或 Email</label>
          <input v-model="loginInput" type="text" placeholder="請輸入登入帳號或 Email" required autocomplete="username" />
        </div>
        <div class="aff-field">
          <label>密碼</label>
          <input v-model="password" type="password" placeholder="請輸入密碼" required autocomplete="current-password" />
        </div>

        <div v-if="error" class="aff-error">{{ error }}</div>

        <button type="submit" class="aff-btn-login" :disabled="loading">
          {{ loading ? '登入中...' : '登入' }}
        </button>

        <p class="aff-forgot-link"><a href="/affiliate/forgot-password">忘記密碼？</a></p>
        <p class="aff-apply-link">尚未申請？<a href="/affiliate/apply">申請成為合作夥伴</a></p>
      </form>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'

const router = useRouter()
const loginInput = ref('')
const password = ref('')
const loading = ref(false)
const error = ref('')

async function login() {
  error.value = ''
  loading.value = true
  try {
    const res = await axios.post('/api/affiliate/login', {
      login: loginInput.value,
      password: password.value
    })
    if (res.data.success) {
      localStorage.setItem('affiliateToken', res.data.token)
      localStorage.setItem('affiliateInfo', JSON.stringify(res.data.affiliate))
      router.push('/affiliate/dashboard')
    } else {
      error.value = res.data.message || '登入失敗'
    }
  } catch (e) {
    error.value = e.response?.data?.message || '伺服器錯誤'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.aff-login-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f0eb 0%, #ede0d4 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
}
.aff-login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.10);
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 400px;
}
.aff-login-logo {
  text-align: center;
  margin-bottom: 1.5rem;
}
.aff-logo-img { height: 48px; margin-bottom: 0.5rem; }
.aff-login-logo h1 { font-size: 1.4rem; color: #4a2c1a; margin: 0.3rem 0; }
.aff-login-form { display: flex; flex-direction: column; gap: 1rem; }
.aff-field { display: flex; flex-direction: column; gap: 0.3rem; }
.aff-field label { font-size: 0.85rem; font-weight: 600; color: #555; }
.aff-field input {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 0.6rem 0.9rem;
  font-size: 0.95rem;
  outline: none;
  transition: border-color 0.2s;
}
.aff-field input:focus { border-color: #8B4513; }
.aff-error { background: #fff0f0; color: #c0392b; padding: 0.7rem 1rem; border-radius: 8px; font-size: 0.9rem; }
.aff-btn-login {
  background: #8B4513;
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 0.8rem;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.aff-btn-login:hover:not(:disabled) { background: #6b3310; }
.aff-btn-login:disabled { background: #ccc; cursor: not-allowed; }
.aff-forgot-link { text-align: right; font-size: 0.83rem; margin-top: -0.3rem; }
.aff-forgot-link a { color: #8B4513; }
.aff-apply-link { text-align: center; font-size: 0.88rem; color: #666; margin-top: 0.3rem; }
.aff-apply-link a { color: #8B4513; font-weight: 600; }
</style>
